import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TapasIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tapas"}/>
}
